import { Trans } from "@lingui/react/macro";

import type { components } from "@/shared/api";

type MatchMode = components["schemas"]["MatchMode"];

// Тип обычного матча в строке: « · рейтинговый» или « · обычный»; прочих — нет.
export const ModeLabel = ({ mode }: { mode: MatchMode | null }) => {
  if (mode === "ranked") {
    return (
      <>
        {" · "}
        <span className="text-accent">
          <Trans>ranked</Trans>
        </span>
      </>
    );
  }
  if (mode === "unranked") {
    return (
      <>
        {" · "}
        <span>
          <Trans>unranked</Trans>
        </span>
      </>
    );
  }
  return null;
};
